import React from "react";
import PropTypes from "prop-types";

const coerceNumber = (v, fallback = 0) =>
    Number.isFinite(Number(v)) ? Number(v) : fallback;

export const FormattedNumber = ({
                                    value,
                                    config: {
                                        precision = 2,
                                        locale = "es-ES",
                                        style = "decimal",
                                        currency = "EUR",
                                        compact = false,
                                        signDisplay = "auto",
                                    } = {}
                                }) => {
    let n = coerceNumber(value, 0);
    if (style === "percent") n = n / 100; // normalize 10 → 0.1

    const formatter = new Intl.NumberFormat(locale, {
        style,
        currency: style === "currency" ? currency : undefined,
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
        notation: compact ? "compact" : "standard",
        signDisplay,
    });

    return <span>{formatter.format(n)}</span>;
};

FormattedNumber.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    config: PropTypes.shape({
        precision: PropTypes.number,
        locale: PropTypes.oneOf(["es-ES", "en-GB", "fr-FR"]),
        style: PropTypes.oneOf(["decimal", "currency", "percent"]),
        currency: PropTypes.oneOf(["EUR"]),
        compact: PropTypes.bool,
        signDisplay: PropTypes.oneOf(["auto", "always", "never", "exceptZero"]),
    }),
};
